"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NutritionOrderAdministration = void 0;
/**
 * A request to supply a diet, formula feeding (enteral) or oral nutritional supplement to a patient/resident.
 */
var NutritionOrderAdministration = /** @class */ (function () {
    function NutritionOrderAdministration() {
    }
    return NutritionOrderAdministration;
}());
exports.NutritionOrderAdministration = NutritionOrderAdministration;
